import { useEffect } from "react";
import ReactGA from "react-ga4";
import { useLocation } from "react-router-dom";

if (!ReactGA.isInitialized) {
  ReactGA.initialize([{ trackingId: "G-3DBSNX32PP" }, { trackingId: "UA-64784451-1" }]);
  /* ReactGA.ga((tracker) => {
    console.debug(tracker.get("clientId"));
  }); */
}

const GoogleAnalytics = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    ReactGA.set({ page: pathname + search });
    ReactGA.send({ hitType: "pageview", page: pathname + search });
  }, [pathname, search]);

  return <div></div>;
};

export default GoogleAnalytics;
